const { SCRIPT_PROP_TYPES } = require('./utils/script-config');

const Script = () => null;

Script.propTypes = SCRIPT_PROP_TYPES;

Script.Script = Script;

module.exports = Script;
